/**
 * addClickReaction() is used for adding generic click reactions.
 */
import type { Container } from 'pixi.js';
import type { SoundType } from '../../app/SoundManager';
import { soundManager } from '../../app/SoundManager';

export enum ClickReactionAnimation {
  QuickScaleIn,
}

interface ClickReactionSettings {
  target: Container;
  reaction?: ClickReactionAnimation;
  animateTargets?: Container[];
  soundType?: SoundType;
}

const animationMap: Record<ClickReactionAnimation, (container: Container) => void> = {
  [ClickReactionAnimation.QuickScaleIn]: (container: Container) => {
    container.tweenTo({ scaleX: 0.95, scaleY: 0.95 }, 100, 'quadOut', true, 0, 0, true);
  },
};

export function addClickReaction({
  target,
  animateTargets,
  reaction = ClickReactionAnimation.QuickScaleIn,
  soundType = 'UI_Button_Click',
}: ClickReactionSettings): void {
  const onPointerTap = (): void => {
    if (soundType) soundManager.play(soundType);
    (animateTargets ?? [target]).forEach(animationMap[reaction]);
  };

  target.on('pointertap', onPointerTap);
}
